import { AppCollection } from '@/stores/AppStore';
import { Response } from 'datx-jsonapi';
import uniq from 'lodash/uniq';
import { LectureStatistic } from '@/resources/LectureStatistic';
import { ThinLecture } from '@/resources/ThinLecture';

export const fetchLectureStatistics = (store: AppCollection) => async (response: Response<ThinLecture>) => {
  const lectureIds = (response.data as Array<ThinLecture>)?.map((lecture) => lecture.id);

  return await store.fetchAll(LectureStatistic, {
    filter: {
      lecture_id: uniq(lectureIds),
    },
  });
};
